import React, {useState, useEffect} from "react";
import {makeStyles} from '@material-ui/core/styles';
import {Grid, CircularProgress, List, ListItem, ListItemAvatar, ListItemText, Divider} from '@material-ui/core';
import Moment from 'react-moment';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    waitingPanel: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "270px"
    },
    mainIcon: {
        width: '70px'
    },
    weatherIcon: {
        width: '50px',
    },
    temp: {
        fontSize: '32px',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    cityName: {
        fontSize: '30px'
    },
    greyFont: {
        color: 'rgba(0, 0, 0, 0.54)',
    },
    subInfo: {
        fontSize: '20px',
        padding: '6px 0 10px'
    }
}));

export default function Weather() {
    const classes = useStyles(),
        [waiting, setWaiting] = useState(true),
        [loading1, setLoading1] = useState(true),
        [loading2, setLoading2] = useState(true),
        [location, setLocation] = useState(null),
        [weather, setWeather] = useState({}),
        [forecast, setForecast] = useState({});


    const formatTemp = temp => {
            return Math.round(temp) + '°';
        },
        renderHourly = () => {
            const data = forecast.hourly.slice(1, 13);

            return (
                <List
                    style={{display: 'flex', flexDirection: 'row', padding: 0, overflow: 'hidden', overflowX: 'auto'}}>
                    {data.map((item, index) => (
                        <ListItem button key={index} style={{height: '80px', minWidth: '130px'}}>
                            <ListItemAvatar>
                                <img alt="" className={classes.weatherIcon}
                                     src={require(`../../../assets/weather/${item.weather[0].icon}@2x.png`)}/>
                            </ListItemAvatar>
                            <ListItemText primary={<div>{formatTemp(item.temp)}</div>}
                                          secondary={<Moment unix format="h A">
                                              {item.dt}
                                          </Moment>}/>
                        </ListItem>
                    ))
                    }
                </List>
            );
        }, renderDaily = () => {
            const data = forecast.daily.slice(1);

            return (
                <List style={{display: 'flex', flexDirection: 'row', padding: 0, overflow: 'hidden', overflowX: 'auto'}}>
                    {data.map((item, index) => (
                        <ListItem button key={index} style={{height: '80px', minWidth: '180px'}}>
                            <ListItemAvatar>
                                <img alt="" className={classes.weatherIcon}
                                     src={require(`../../../assets/weather/${item.weather[0].icon}@2x.png`)}/>
                            </ListItemAvatar>
                            <ListItemText primary={<div>{formatTemp(item.temp.max)} <span
                                className={classes.greyFont}>{formatTemp(item.temp.min)}</span></div>}
                                          secondary={<Moment unix format="dddd">
                                              {item.dt}
                                          </Moment>}/>
                        </ListItem>
                    ))
                    }
                </List>
            );
        };

    //get geo
    useEffect(() => {
        setWaiting(true);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                setLocation({
                    lat: position.coords.latitude,
                    lon: position.coords.longitude
                });
                setWaiting(false);
            });
        }

    }, []);

    //get current weather
    useEffect(() => {
        if (!location) return;
        console.log(location);
        setLoading1(true);
        fetch(`https://openweathermap.org/data/2.5/weather?lat=${location.lat}&lon=${location.lon}&appid=439d4b804bc8187953eb36d2a8c26a02`)
            .then(response => response.json())
            .then(data => {
                console.log(data);
                setWeather(data);
                setLoading1(false);
            });
    }, [waiting]);

    //get forecast
    useEffect(() => {
        if (!location) return;
        console.log(location);
        setLoading2(true);
        fetch(`https://openweathermap.org/data/2.5/onecall?lat=${location.lat}&lon=${location.lon}&appid=439d4b804bc8187953eb36d2a8c26a02`)
            .then(response => response.json())
            .then(data => {
                console.log(data);
                setForecast(data);
                setLoading2(false);
            });
    }, [waiting]);

    if (waiting) {
        return <div className={classes.waitingPanel}>Please allow Intranet to access your location.</div>;
    }

    if (loading1 || loading2) {
        return <div className={classes.waitingPanel}><CircularProgress/></div>;
    }

    return (
        <div>
            <Grid container>
                <Grid item xs={6}>
                    <div>{forecast.current.weather[0].main}</div>
                    <div className={classes.cityName}>{weather.name}</div>
                </Grid>
                <Grid item xs={6} className={classes.temp}>
                    <img alt="" className={classes.mainIcon}
                         src={require(`../../../assets/weather/${forecast.current.weather[0].icon}@2x.png`)}/>
                    {formatTemp(forecast.current.temp)}
                </Grid>
            </Grid>
            <Grid item container className={classes.subInfo}>
                <Grid item xs={6} className={classes.greyFont}>
                    <Moment format="dddd">{new Date()}</Moment>
                </Grid>
                <Grid item xs={6} style={{textAlign: 'right'}}>
                    {formatTemp(forecast.daily[0].temp.max)} <span
                    className={classes.greyFont}>{formatTemp(forecast.daily[0].temp.min)}</span>
                </Grid>
            </Grid>
            <Divider/>
            <div>
                {renderHourly()}
            </div>
            <Divider/>
            <div>
                {renderDaily()}
            </div>
        </div>
    );
}